import '@loyal_modules/carousel/css/owl.carousel.css'
import '@loyal_modules/carousel/css/owl.theme.default.min.css'

import React, { Fragment, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import MainBanner from './components/MainBanner'
import Benefits from './components/Benefits'
import SecondaryBanner from './components/SecondaryBanner'
import Help from './components/Help'

const HomePage = ({ profile }) => {
  const target = window.location.hash
  const targetRef = useRef()
  const getTargetRef = () => ({ ref: targetRef })
  window.location.hash = ''
  const title = ''
  useEffect(() => {
    const headerSize = window.innerWidth >= 1024 ? 100 : 60
    if (target) {
      window.scrollTo({
        top: targetRef.current.offsetTop - headerSize,
        behavior: 'smooth'
      })
    }
  }, [target])
  return (
    <Fragment>
      <Helmet>
        <title>{`${process.env.REACT_APP_TITLE || ''}`}</title>
      </Helmet>
      <div className='home-disconnected meu-bairro'>
        <MainBanner />
        <Benefits id='benefits' {...(target && target === '#benefits' && getTargetRef())} />
        <SecondaryBanner />
        <Help id='help' {...(target && target === '#help' && getTargetRef())} />
      </div>
    </Fragment>
  )
}

HomePage.propTypes = {
  profile: PropTypes.object
}

export default HomePage



// WEBPACK FOOTER //
// ./src/HomePageItauMeuBairro/HomePageItau.js